import styled from "styled-components";

const ModalHeading = styled.h3`
	border-bottom: 1px solid #eaeaea;
	padding-bottom: 1em;
`;

export default ModalHeading;
